import { create } from 'zustand'

// ─── Preview sound store ────────────────────────────────────────────────────
//
// Mute state for composer video previews, keyed PER POST (not per platform
// creative). A post's TikTok / YouTube / Instagram-Reel tabs are separate
// sibling creatives, so we key on `projectId` (falling back to the creative id
// for legacy single-platform posts) — muting one tab mutes them all, and the
// choice survives the tab-switch remount because it lives outside the preview
// components.
//
// Absence of an entry means UNMUTED: videos enter the composer with sound on,
// and the user can mute. Intentionally NOT persisted — each session starts
// unmuted again.

interface PreviewSoundStore {
  /** postKey → muted. Missing key = unmuted (default sound on). */
  mutedByPost: Record<string, boolean>
  setMuted: (postKey: string, muted: boolean) => void
}

export const usePreviewSoundStore = create<PreviewSoundStore>(set => ({
  mutedByPost: {},
  setMuted: (postKey, muted) =>
    set(state => ({
      mutedByPost: { ...state.mutedByPost, [postKey]: muted },
    })),
}))
